<template>
  <div>
    <v-dialog :modelValue="open" max-width="420" persistent @keydown.esc="$emit('close')">
      <v-card>
        <v-card-title class="d-flex align-center pa-4 text-white" style="background-color: #ec0000;">
          <v-icon class="mr-2" size="26">mdi-alert-circle</v-icon>
          {{ title }}
        </v-card-title>

        <v-card-text class="pt-5 pb-2">
          <div class="d-flex align-start">
            <v-icon size="22" class="mr-3 mt-1" style="color: #ec0000;">mdi-information-outline</v-icon>
            <p class="mb-0 fs-16">{{ message }}</p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="elevated" style="background-color: #ec0000; color: white;" @click="$emit('close')">
            <v-icon start>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    open: Boolean,
  },
  emits: ["close"],
  data: () => ({}),
  methods: {},
};
</script>
